import {RESPONSE} from "../../../../../../constants/ResponseCodes";
import {VIEW} from "../../../../../workflow/Workflow";
import {NOTIFICATION_TYPE} from "../../../../../../constants/NotificationType";
import {COMMON_STRINGS, NOTIFICATION_STRING} from "../../../../../../constants/Strings";
import {CONTAINER_TYPE} from "../../../../../../constants/ContainerType";
import {getContainerRoutingPath, ROUTING} from "../../../../../../constants/Routing";
import {getNotificationFormat} from "../../../../../utils/Util";
import {SCOPE} from "../../../../../../constants/Scope";

export const getScanOvCartViewData = (input) => {
    const values = {
        scannedCartId: input.activeCartId,
        destinationLabel: input.existingLocationLabel
    }

    switch (input.responseCode) {
        case RESPONSE.SUCCESS:
            return {
                view: SCOPE.SSD === input.scope ? VIEW.SCAN_CONTAINER_LOCATION : VIEW.SCAN_CART_LOCATION
            }
        case RESPONSE.NO_INTERNET:
            return {
                nextRoute: ROUTING.NO_INTERNET
            }
        case RESPONSE.INVALID_SCAN_DONE:
            return {
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, NOTIFICATION_STRING.ALERT_ERROR_INVALID_CART_SCAN, values)
            }
        case RESPONSE.NON_EMPTY_CART:
            return {
                nextRoute: getContainerRoutingPath(ROUTING.REPLACE_CONTAINER, CONTAINER_TYPE.CART),
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, NOTIFICATION_STRING.ALERT_ERROR_CART_CANT_BE_USED, values)
            }
        case RESPONSE.CART_ALREADY_ATTACHED:
            return {
                notification: getNotificationFormat(NOTIFICATION_TYPE.WARNING, NOTIFICATION_STRING.ALERT_WARNING_CART_ALREADY_ATTACHED, values)
            }
        default:
            return {
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, COMMON_STRINGS.default_error)
            }
    }
}
